import { computed } from 'vue';
import { IPresentableEntity } from '@/models/available-entities.interface';
import store from '@/store';

class EntityVisibilityPresenter {

	private availableEntities = computed((): IPresentableEntity[] => {
		return store.getters.availableEntities();
	});

	public isParentHidden(entity: IPresentableEntity): boolean {
		return entity.relevantParentIndexes.find(
			(index: number) => this.availableEntities.value[index].hideChildren
		) !== undefined;
	}
}

export default new EntityVisibilityPresenter();
